import PasswordResetSuccess from "../components/PasswordResetSuccess/PasswordResetSuccess";
import useNavigation from "../hooks/navigation";

const PasswordResetSuccessContainer = () => {
  const navigation = useNavigation();

  return <PasswordResetSuccess onBackToLoginClick={() => navigation.goToSignIn()} />;
};

export default PasswordResetSuccessContainer;
